<template>
  <div class="main-header-pc">
    <div :class="{ 'pc-header-box': true, 'change-header': (changeHeader || $route.path === '/faq') }">
      <div class="pc-header-content">
        <div class="logo-in-header">
          <router-link to="/"
            ><img src="/static/img/home/header_logo.png" alt=""
          /></router-link>
        </div>
        <div class="header-nav">
          <ul>
            <li>
              <router-link to="/">{{ $t("index") }}</router-link>
            </li>
            <li>
              <router-link to="/download">{{ $t("download") }}</router-link>
            </li>

            <li class="signUp" v-if="!isLoginPage">
              <router-link :to="!hasToken ? '/register' : '/dashboard'"
                >{{ $t("discount1") }} {{ bigstCount
                }}{{ $t("discount2") }}</router-link
              >
            </li>

            <div v-if="!hasToken">
              <li v-if="!isLoginPage">
                <router-link to="/login">{{ $t("signIn") }}</router-link>
              </li>
            </div>
            <div v-else>
              <li>
                <account-info></account-info>
              </li>
            </div>

            <li style="height: 20px">
              <choose-lang></choose-lang>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import locales from "./lang";
import LogoInHeader from "../../logoInHeader/LogoInHeader.vue";
import ChooseLang from "../../ChooseLang.vue";
import AccountInfo from "./accountInfo/AccountInfo.vue";
import { mapState } from "vuex";

export default {
  name: "pc-header",
  components: { LogoInHeader, ChooseLang, AccountInfo },
  locales,
  data() {
    return {
      bigstCountTimer: null,
      changeHeader: false,
    };
  },
  computed: {
    langIsZh() {
      return this.$store.state.currentLang === "zh";
    },
    ...mapState({
      hasToken: (state) => state.hasToken,
      user: (state) => state.user,
      specialHeader: (state) => state.header.specialHeader,
      bigstCount: (state) => state.header.bigstCount,
      isLoginPage: (state) => state.header.isLoginPage,
      isdownload: (state) => state.header.isdownload,
      isHeader: "isHeader",
    }),
    customLogoColor() {
      return "#fff";
    },
  },
  mounted() {
    this.bigstCountTimer = setTimeout(() => {
      if (this.bigstCount <= 0 && !this.isLoginPage) {
        this.getBigstCount();
      }
    }, 3000);
    // mounted监听处理;
    window.addEventListener("scroll", this.scrollLoadMore);
  },
  destroyed() {
    clearTimeout(this.bigstCountTimer);
  },
  methods: {
    scrollLoadMore() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      if (scrollTop > 0) {
        this.changeHeader = true;
      } else {
        this.changeHeader = false;
      }
    },
    getBigstCount() {
      this.$http
        .get("api/v2/topup-packages", {
          headers: {
            "Cache-Control": "no-cache",
          },
        })
        .then((response) => {
          var num = 0;
          response.body.data.forEach((el) => {
            if (el.type !== "svip") {
              if (
                Number(100 - (el.price / el.list_price) * 100).toFixed(0) >= num
              ) {
                num = (100 - (el.price / el.list_price) * 100).toFixed(0);
              }
            }
          });
          this.$store.commit("getBigstCount", num);
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../assets/scss/variables";
@import "../../../assets/scss/mixins/gradient";
@import "../../../assets/scss/activity";

* {
  padding: 0;
  margin: 0;
}
ul {
  list-style: none;
}
.main-header-pc {
  width: 100%;
  position: relative;
  overflow: hidden;
  .change-header {
    background-color: #fff;
  }
  .pc-header-box {
    position: fixed;
    width: 100%;
    top: 0;
    .pc-header-content {
      max-width: 11.8rem;
      height: 80px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo-in-header {
        width: 180px;
        line-height: 100%;
        text-align: center;

        img {
          width: 100%;
          height: 40px;
          object-fit: contain;
          vertical-align: middle;
        }
      }
      .header-nav {
        ul {
          display: flex;
          align-items: center;
          li {
            &:not(:last-child), &:first-child {
              margin-right: 32px;
            }
            a {
              font-size: 16px;
              color: #333333;
              letter-spacing: 0.89px;
              text-align: center;
              font-weight: 500;
            }
          }
          .signUp {
            padding: 5px 21px;
            background: #fff;
            border: 1px solid rgba(51, 51, 51, 1);
            border-radius: 100px;
          }
        }
      }
      @media screen and (max-width: 1228px) {
        padding: 0 24px;
      }
    }
  }
}

.content {
  max-width: 11rem;
  margin: 0 auto;
  clear: both;
  height: 0.8rem;
  line-height: 0.8rem;
  &:after {
    overflow: hidden;
    clear: both;
    content: "";
    display: block;
    visibility: hidden;
  }
}

@mixin default-theme() {
  background: #fff;
  .nav-bar li.signUp a {
    color: #333;
  }
  .nav-bar li a {
    color: #333;
  }
  .nav-bar li.signUp {
    border: 1px solid $base-blue;
  }
}

@mixin transparent-theme() {
  background-color: transparent;
  // -webkit-background-color: transparent;
  .nav-bar li.signUp a,
  .nav-bar li a {
    color: $header-transparent-theme-color;
  }
  .nav-bar li.signUp {
    border: 1px solid $header-transparent-theme-color;
  }
  .test {
    color: red;
  }
}

@mixin gradient-theme() {
  background: transparent;
  .nav-bar li.signUp a,
  .nav-bar li a {
    color: #fff;
  }
  .nav-bar li.signUp {
    border: 1px solid #fff;
  }
  .test {
    color: red;
  }
  @include gradient-background(-135deg, #ec55ff 0%, #416cf8 100%);
}

.main-header-pc {
  @include default-theme();
  &.gradient-theme {
    @include gradient-theme();
  }
  &.transparent-theme {
    @include transparent-theme();
  }
}
</style>



// WEBPACK FOOTER //
// MainHeaderPc.vue?573f471f